import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getActiveAnalysisSet } from './getActiveAnalysisSetSelector';
import { getAnalysisResultRequestsForActiveAnalysisSet } from './getAnalysisResultsForActiveAnalysisSetSelector';

export const getPossibleAnalysisResultRequestsForActiveLoadCase = createSelector(
  (state: RootState) => state.analysisResultRequests,
  (state: RootState) => state.selections.selectedCheckResultsLoadCaseGuid,
  getActiveAnalysisSet,
  getAnalysisResultRequestsForActiveAnalysisSet,
  (analysisResultRequests, selectedLoadCaseGuid, analysisSet, analysisResultRequestsForActiveAnalysisSet) => {
    if (!selectedLoadCaseGuid) {
      return null;
    }
    const analysisResultGuidsByLoadCase = analysisSet?.analysisResultGuidsByLoadCase ?? null;
    if (analysisResultGuidsByLoadCase) {
      return [analysisResultRequests[analysisResultGuidsByLoadCase[selectedLoadCaseGuid]] ?? null];
    }
    // We can remove the remaining case(s) and just return the single request object instead of multiple possible
    // request objects once
    // https://github.com/ParagonTruss/ParagonCore/blob/d9c29787809e0ba345ca5e69c28cc40355f38c4f/servers/apps/Affenpinscher/Migrations/PopulateAnalysisResultGuidsByLoadCase.cs
    // has been run.
    if (!analysisResultRequestsForActiveAnalysisSet) {
      return null;
    }
    const loadedRequest = analysisResultRequestsForActiveAnalysisSet.find(
      (request) => request?.status === 'loaded' && request.item.loadCaseGuid === selectedLoadCaseGuid,
    );
    if (loadedRequest) {
      return [loadedRequest];
    }
    return analysisResultRequestsForActiveAnalysisSet.filter((request) => request?.status !== 'loaded');
  },
);
